import getCombatantIndexById from './getCombatantIndexById'
import store from '../store/index'
import pendingReaction from '../assets/images/bbPendingReaction.png'
//----------------
// set pending CR
//----------------
export default function setPendingCR(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat
  let combatants = this_store.arena.arena_combatants
  //------------------
  // get combatant idx
  //------------------
  let i = getCombatantIndexById(parm.id)
  //------------------
  // set var cr props
  //------------------
  let cr = 'cr' + parm.cr_num
  let cr_name = 'cr_name' + parm.cr_num
  let cr_slug = 'cr_slug' + parm.cr_num
  //------------------
  // set pending slot
  //------------------
  combatants[i][cr] = pendingReaction
  combatants[i][cr_name] = 'pending'
  combatants[i][cr_slug] = ''
}
